import React, { useEffect, useState, useRef } from 'react'
import {
    Table,
    Container,
    Row,
} from 'reactstrap';

import DetailTable from 'components/Orders/BrandOrderDetailTable';
import EditBatch from './EditBatch';
import api from 'api';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Spinner from "components/Spinner/Spinner";
import moment from "moment";
import { MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import ArrowBack from "../../assets/LeftArrow.svg";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg"
import ArrowForward from "../../assets/RIghtArrow.svg";
import { UpdateStore } from 'StoreContext';
import { Store } from 'StoreContext';


const Orders = () => {
    const [orders, setOrders] = useState([]);
    const [filterOrders, setFilterOrders] = useState([]);
    const [orderScanStats, setOrderScanStats] = useState({});
    const update = UpdateStore()
    const { totalRecords, user } = Store()
    const [page, setPage] = useState(1);
    const pageSize = 20;
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const brandOrderSentinelRef = useRef(null);
    const [expandedMobile, setExpandedMobile] = useState({});
    const [editingBatch, setEditingBatch] = useState(null);
    const [lookupQuery, setLookupQuery] = useState('');
    const [lookupResult, setLookupResult] = useState(null);
    const [lookupLoading, setLookupLoading] = useState(false);

    const handleCodeLookup = () => {
        if (!lookupQuery.trim()) {
            toast.error("Enter a code to search");
            return;
        }
        setLookupLoading(true);
        setLookupResult(null);
        api('get', `/codes/lookup?code=${encodeURIComponent(lookupQuery.trim())}&brandId=${user?._id}`)
            .then((res) => {
                setLookupLoading(false);
                setLookupResult(res);
            })
            .catch((err) => {
                setLookupLoading(false);
                toast.error("Failed to look up code");
            });
    };

    const getOrders = (pageNum, append) => {
        setLoading(true)
        api('get', `/orders?brandId=${user?._id}&page=${pageNum || page}&pageSize=${pageSize}`).then((res) => {
            setLoading(false)
            const newOrders = res?.orders || [];
            if (append) {
                setOrders(prev => [...prev, ...newOrders]);
                setFilterOrders(prev => [...prev, ...newOrders]);
            } else {
                setOrders(newOrders);
                setFilterOrders(newOrders);
            }
            setHasMore(newOrders.length >= pageSize);
            update({ totalRecords: res.totalRecords });
            fetchAllScanStats(append ? [...orders, ...newOrders] : newOrders);
        }).catch((err) => {
            setLoading(false)
            console.log(err)
        })
    }

    const fetchAllScanStats = async (ordersList) => {
        if (!ordersList.length) return;
        const statsMap = {};
        await Promise.allSettled(
            ordersList.map((order) =>
                api('get', `/codes/scan-stats/order/${order._id}`)
                    .then((res) => {
                        const states = res?.states || res?.topStates || [];
                        const countries = res?.countries || res?.topCountries || [];
                        statsMap[order._id] = {
                            topState: states.length > 0 ? (typeof states[0]?.state === 'string' ? states[0].state : (typeof states[0]?._id === 'string' ? states[0]._id : '-')) : '-',
                            topCountry: countries.length > 0 ? (typeof countries[0]?.country === 'string' ? countries[0].country : (typeof countries[0]?._id === 'string' ? countries[0]._id : '-')) : '-',
                        };
                    })
                    .catch(() => {
                        statsMap[order._id] = { topState: '-', topCountry: '-' };
                    })
            )
        );
        setOrderScanStats(statsMap);
    };

    useEffect(() => {
        getOrders(page, page > 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    useEffect(() => {
        if (!brandOrderSentinelRef.current) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !loading) {
                    setPage(p => p + 1);
                }
            },
            { threshold: 0.1 }
        );
        observer.observe(brandOrderSentinelRef.current);
        return () => observer.disconnect();
    }, [hasMore, loading]);

    const headerStyle = {
        borderTop: 'none',
        background: 'white',
        fontSize: '16px',
        fontWeight: 600,
        color: '#1C1C1C',
        textTransform: "capitalize",
        letterSpacing: 0
    };

    return (
        <>
            <Container fluid>
                {loading && <Spinner />}

                <div className='d-flex justify-content-between align-items-center pb-3'>
                    <h1 className="vs-page-title">Orders</h1>
                </div>

                {/* Code Lookup */}
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    padding: '14px 20px',
                    marginBottom: '16px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    fontFamily: 'Outfit',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#362FD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                        <input
                            type="text"
                            value={lookupQuery}
                            onChange={(e) => setLookupQuery(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleCodeLookup()}
                            placeholder="Look up a code — find which batch it belongs to"
                            style={{
                                flex: 1,
                                border: 'none',
                                outline: 'none',
                                fontSize: '14px',
                                fontFamily: 'Outfit',
                                backgroundColor: 'transparent',
                            }}
                        />
                        <button
                            onClick={handleCodeLookup}
                            disabled={lookupLoading}
                            style={{
                                backgroundColor: '#362FD8',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '6px 16px',
                                fontSize: '13px',
                                fontWeight: 600,
                                fontFamily: 'Outfit',
                                cursor: 'pointer',
                                opacity: lookupLoading ? 0.6 : 1,
                            }}
                        >
                            {lookupLoading ? 'Searching...' : 'Search'}
                        </button>
                        {lookupResult && (
                            <button
                                onClick={() => { setLookupResult(null); setLookupQuery(''); }}
                                style={{ background: 'none', border: 'none', color: '#999', cursor: 'pointer', fontSize: '18px', padding: '0 4px' }}
                            >×</button>
                        )}
                    </div>
                    {lookupResult && (
                        <div style={{ marginTop: '12px', padding: '12px', backgroundColor: lookupResult.found ? '#f0fdf4' : '#fef2f2', borderRadius: '8px', fontSize: '13px' }}>
                            {lookupResult.found ? (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
                                    <div>
                                        <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Code:</span>{' '}
                                        <span style={{ fontFamily: 'monospace', color: '#362FD8' }}>{lookupResult.code?.code}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Status:</span>{' '}
                                        <span className="rounded-pill" style={{
                                            padding: '2px 8px',
                                            fontSize: '11px',
                                            backgroundColor: lookupResult.code?.status === 'validated' ? 'rgba(0,178,7,0.1)' : lookupResult.code?.status === 'pending' ? 'rgba(54,47,216,0.1)' : 'rgba(255,0,0,0.1)',
                                            color: lookupResult.code?.status === 'validated' ? '#00B207' : lookupResult.code?.status === 'pending' ? '#362FD8' : 'red',
                                        }}>{lookupResult.code?.status}</span>
                                    </div>
                                    {lookupResult.batch && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Batch:</span>{' '}
                                            <span>{lookupResult.batch?.productName || 'Unnamed'}</span>
                                        </div>
                                    )}
                                    {lookupResult.order && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Order:</span>{' '}
                                            <span>{lookupResult.order?.orderNumber}</span>
                                        </div>
                                    )}
                                    {lookupResult.code?.scanAttempts > 0 && (
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#1C1C1C' }}>Scans:</span>{' '}
                                            <span>{lookupResult.code?.scanAttempts}</span>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{ color: '#dc3545', fontWeight: 500 }}>
                                    ⚠ Code not found for this brand. Check the code and try again.
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Desktop Table */}
                <Row className="d-none d-md-block">
                    <div className='col'>
                        <Table style={{ fontFamily: 'Outfit' }} className='align-items-center table-flush' responsive>
                            <thead className='thead-light'>
                                <tr>
                                    <th style={{
                                        borderTopLeftRadius: '10px',
                                        borderTop: 'none',
                                        background: 'white'
                                    }} scope='col' />
                                    <th style={headerStyle} scope='col'>Order #</th>
                                    <th style={headerStyle} scope='col'>Products</th>
                                    <th style={{ ...headerStyle, textAlign: 'center' }} scope='col'>Code Type</th>
                                    <th style={{ ...headerStyle, textAlign: 'center' }} scope='col'>Status</th>
                                    <th style={{ ...headerStyle, textAlign: 'center' }} scope='col'>Total Scans</th>
                                    <th style={{ ...headerStyle, textAlign: 'center' }} scope='col'>Top Location</th>
                                    <th style={headerStyle} scope='col'>Date</th>
                                    <th style={{
                                        ...headerStyle,
                                        borderTopRightRadius: '10px',
                                        textAlign: 'center',
                                    }} scope='col'>Map</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filterOrders?.map((item, index) => {
                                    return (
                                        <DetailTable
                                            key={item._id || index}
                                            item={item}
                                            arr={orders}
                                            index={index}
                                            scanStats={orderScanStats[item._id]}
                                            getOrders={getOrders}
                                        />
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                </Row>

                {/* Mobile Cards */}
                <div className="d-block d-md-none" style={{ fontFamily: 'Outfit' }}>
                    {filterOrders?.map((item) => {
                        const hasPending = item.batchIds?.some(b => b.status === 'pending');
                        const totalCodes = item.batchIds?.reduce((s, b) => s + (b.number_of_codes || 0), 0) || 0;
                        const stats = orderScanStats[item._id] || {};
                        const isExp = expandedMobile[item._id];
                        return (
                            <div key={item._id} style={{
                                backgroundColor: '#fff', borderRadius: '10px', padding: '14px 16px',
                                marginBottom: '10px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                    <div style={{ fontWeight: 600, fontSize: '14px', color: '#1C1C1C' }}>
                                        {item.description || `Order #${String(item._id).slice(-6)}`}
                                    </div>
                                    <span style={{
                                        padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 500,
                                        backgroundColor: hasPending ? 'rgba(255,0,0,0.08)' : 'rgba(0,178,7,0.08)',
                                        color: hasPending ? '#dc3545' : '#00B207',
                                    }}>{hasPending ? 'Pending' : 'Approved'}</span>
                                </div>
                                <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>
                                    {item.batchIds?.length || 0} batch{item.batchIds?.length !== 1 ? 'es' : ''} · {totalCodes.toLocaleString()} codes · {moment(item.createdAt).format('MMM DD, YYYY')}
                                </div>
                                {stats.topState && stats.topState !== '-' && (
                                    <div style={{ fontSize: '11px', color: '#999', marginBottom: '6px' }}>
                                        Top: {stats.topState}{stats.topCountry && stats.topCountry !== '-' ? ` · ${stats.topCountry}` : ''}
                                    </div>
                                )}
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }}
                                        onClick={() => setExpandedMobile(p => ({ ...p, [item._id]: !p[item._id] }))}>
                                        {isExp ? 'Hide batches' : 'View batches'}
                                    </span>
                                </div>
                                {isExp && item.batchIds?.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        {item.batchIds.map(batch => {
                                            const batchScans = batch?.totalBatchScans || 0;
                                            const batchIsPending = batch.status === 'pending';
                                            return (
                                                <div key={batch._id} style={{
                                                    padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '8px',
                                                    marginBottom: '6px', fontSize: '13px',
                                                }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                                                        <div style={{ fontWeight: 600, color: '#333' }}>{batch.product_name || 'Untitled'}</div>
                                                        <span style={{
                                                            padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 500,
                                                            backgroundColor: batchIsPending ? 'rgba(255,0,0,0.08)' : 'rgba(0,178,7,0.08)',
                                                            color: batchIsPending ? '#dc3545' : '#00B207',
                                                        }}>{batch.status ? batch.status.charAt(0).toUpperCase() + batch.status.slice(1) : 'Pending'}</span>
                                                    </div>
                                                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '8px' }}>
                                                        {(batch.number_of_codes || 0).toLocaleString()} codes · {batchScans} {batchScans === 1 ? 'scan' : 'scans'}
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <button
                                                            onClick={() => setEditingBatch(batch)}
                                                            style={{
                                                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                                fontSize: '12px', color: '#362FD8', background: 'none',
                                                                border: '1px solid #E4E4E4', borderRadius: '6px',
                                                                padding: '5px 12px', cursor: 'pointer', fontFamily: 'Outfit',
                                                            }}
                                                        >
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                                            </svg>
                                                            Edit
                                                        </button>
                                                        <Link
                                                            to={`/brand/map?orderId=${item._id}&batchId=${batch._id}`}
                                                            style={{
                                                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                                fontSize: '12px', color: '#362FD8', textDecoration: 'none',
                                                                border: '1px solid #E4E4E4', borderRadius: '6px',
                                                                padding: '5px 12px',
                                                            }}
                                                        >
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#362FD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                                                                <circle cx="12" cy="10" r="3" />
                                                            </svg>
                                                            Map
                                                        </Link>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div ref={brandOrderSentinelRef} style={{ height: '1px' }} />
                {loading && (
                    <div style={{ textAlign: 'center', padding: '16px', fontFamily: 'Outfit', color: '#888', fontSize: '13px' }}>Loading more...</div>
                )}
                {!hasMore && filterOrders?.length > 0 && (
                    <div style={{ textAlign: 'center', padding: '12px', fontFamily: 'Outfit', color: '#aaa', fontSize: '12px' }}>All orders loaded</div>
                )}
            </Container>
            {editingBatch && (
                <EditBatch
                    selectedBatch={editingBatch}
                    handleModal={() => setEditingBatch(null)}
                    getOrders={() => getOrders(1, false)}
                />
            )}
        </>
    )
}

export default Orders
